import type { DuaWorkspaceDatabase } from "../database";
import { MemorisationRepository } from "./memorisation-repository";
import { CollectionRepository, PersonRepository, TagRepository } from "./organization-repositories";
import { PersonalDuaRepository } from "./personal-dua-repository";
import { ReflectionRepository } from "./reflection-repository";
import type { RepositoryOptions } from "./repository-utils";
import { SessionRepository } from "./session-repository";
import { MetadataRepository, SettingsRepository } from "./settings-repository";

export * from "./memorisation-repository";
export * from "./organization-repositories";
export * from "./personal-dua-repository";
export * from "./reflection-repository";
export * from "./repository-utils";
export * from "./session-repository";
export * from "./settings-repository";

export function createRepositories(database: DuaWorkspaceDatabase, options: RepositoryOptions = {}) {
  return {
    personalDuas: new PersonalDuaRepository(database, options),
    collections: new CollectionRepository(database, options),
    tags: new TagRepository(database, options),
    people: new PersonRepository(database, options),
    reflections: new ReflectionRepository(database, options),
    sessions: new SessionRepository(database, options),
    memorisation: new MemorisationRepository(database, options),
    settings: new SettingsRepository(database, options),
    metadata: new MetadataRepository(database, options),
  } as const;
}

export type Repositories = ReturnType<typeof createRepositories>;
